/**
 * AthleteBookingsPage.js
 * Pagina dedicata per il Portale Atleti che raggruppa in schede (Tabs):
 * 1. Prenota Lezioni & Slot (AthleteBookingSection)
 * 2. Le Mie Lezioni & Appuntamenti (AthleteScheduleSection)
 */

import React, { useState } from 'react';
import { Card, Tabs, Tab } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import AthleteBookingSection from './AthleteBookingSection';
import AthleteScheduleSection from './AthleteScheduleSection';
import '../../styles/AcrosportTheme.css';

const AthleteBookingsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTabParam = searchParams.get('tab');
  const initialTab = currentTabParam === 'schedule' ? 'schedule' : 'book';
  const [activeTab, setActiveTab] = useState(initialTab);

  const handleSelectTab = (tabKey) => {
    if (!tabKey) return;
    setActiveTab(tabKey);
    setSearchParams({ tab: tabKey }, { replace: true });
  };

  return (
    <div className="athlete-bookings-page acrosport-theme py-2" data-testid="athlete-bookings-page">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4">
        <div>
          <h2 className="mb-1 fw-bold">
            <i className="fas fa-calendar-alt text-primary me-2"></i>
            Lezioni & Prenotazioni
          </h2>
          <p className="text-muted mb-0">
            Prenota gli slot disponibili per i tuoi corsi e consulta le tue lezioni e appuntamenti programmati.
          </p>
        </div>
        <div>
          <Link
            to="/portal/profile"
            className="btn btn-outline-secondary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
          >
            <i className="fas fa-user-circle"></i>
            <span>Torna al Profilo</span>
          </Link>
        </div>
      </div>

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body className="p-0">
          <Tabs
            id="athlete-bookings-tabs"
            activeKey={activeTab}
            onSelect={handleSelectTab}
            unmountOnExit
            mountOnEnter
            className="border-bottom px-3 pt-3 bg-light-subtle"
          >
            <Tab
              eventKey="book"
              title={
                <span className="d-inline-flex align-items-center py-1">
                  <i className="fas fa-calendar-plus me-2 text-primary"></i>
                  <span className="fw-semibold">Prenota Lezioni & Slot</span>
                </span>
              }
            >
              <div className="p-3 p-md-4">
                <AthleteBookingSection />
              </div>
            </Tab>
            <Tab
              eventKey="schedule"
              title={
                <span className="d-inline-flex align-items-center py-1">
                  <i className="fas fa-calendar-check me-2 text-success"></i>
                  <span className="fw-semibold">Le Mie Lezioni & Appuntamenti</span>
                </span>
              }
            >
              <div className="p-3 p-md-4">
                <AthleteScheduleSection />
              </div>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AthleteBookingsPage;
